import { AutorisationContracter } from "../../model/AutorisationContracter";

export const initialState: AutorisationContracter = {
    prenom: "",
    nomLegalEntrepriseNumeroClient: "",
    nom: "",
    courriel: "",
    telephone: "",
    sujet: "",
    message: "",
};